import { intersect, literal, partial, struct } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { Token } from './Token';

export const Request = intersect(
	struct({
		type: literal('indefinite'),
	})
)(
	partial({
		paginationToken: Token,
		size: iotsUtils.PositiveIntegerUpTo(constants.api.pagination.maxPageSize),
	})
);
